import { render, staticRenderFns } from "./IconStats.vue?vue&type=template&id=57cf7245&"
import script from "./IconStats.vue?vue&type=script&lang=js&"
export * from "./IconStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports